export const DashboardActions = {
  SetWorking: 'SET_WORKING',
  SetError: 'SET_ERROR',
  SetCurrent: 'SET_CURRENT',
  AddResult: 'ADD_RESULT',
  UpdateResult: 'UPDATE_RESULT',
};
